/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from "../runtime";
/**
 * Check if a given object implements the Job interface.
 */
export function instanceOfJob(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "isCustom" in value;
    return isInstance;
}
export function JobFromJSON(json) {
    return JobFromJSONTyped(json, false);
}
export function JobFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json.id,
        name: !exists(json, "name") ? undefined : json.name,
        isCustom: json.isCustom,
        physicalActivity: !exists(json, "physicalActivity")
            ? undefined
            : json.physicalActivity,
        mentalActivity: !exists(json, "mentalActivity")
            ? undefined
            : json.mentalActivity,
    };
}
export function JobToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        name: value.name,
        isCustom: value.isCustom,
        physicalActivity: value.physicalActivity,
        mentalActivity: value.mentalActivity,
    };
}
